import { render, staticRenderFns } from "./designController.vue?vue&type=template&id=99e9a096&"
import script from "./designController.vue?vue&type=script&lang=ts&"
export * from "./designController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports